import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Contact } from './contact.state';
import { getUniqueUserId } from '../utils';

export const contactAdapter: EntityAdapter<Contact> = createEntityAdapter<
  Contact
>({
  selectId: getUniqueUserId,
});
